"use strict";
import { Observer, observer } from "mobx-react";
import React from "react";
const LayerContext = React.createContext({
  currentZIndex: 0
});
const Layer = observer(({ children, offset = 1 }) => {
  return /* @__PURE__ */ React.createElement(LayerContext.Consumer, null, ({ currentZIndex }) => /* @__PURE__ */ React.createElement(Observer, null, () => /* @__PURE__ */ React.createElement(
    LayerContext.Provider,
    {
      value: {
        currentZIndex: currentZIndex + offset
      }
    },
    children({ zIndex: currentZIndex + offset })
  )));
});
const OVERLAY_ZINDEX = 890;
const AngularOverlayProvider = observer(
  ({ children }) => /* @__PURE__ */ React.createElement(LayerContext.Provider, { value: { currentZIndex: OVERLAY_ZINDEX } }, children)
);
export { AngularOverlayProvider, Layer };
